<template>
    <span>
        <venn-diagram-controller :element="rootElement.querySelector('#venn-diagram')"/>
        <venn-area-controller
            v-for="vae in vennAreaElements"
            :key="`venn-area-controller-${vae.sceneId}`"
            :sceneId="vae.sceneId"
            :element="vae.element"
            :i="vae.i"
        />
        <venn-title-controller
            v-for="vte in vennTitleElements"
            :key="`venn-title-controller-${vte.sceneId}`"
            :sceneId="vte.sceneId"
            :element="vte.element"
            :i="vte.i"
        />

        <venn-intro-controller v-if="$store.state.scene === 'intro'" :rootElement="rootElement"/>
    </span>
</template>

<script>
import controllerComponents from './ControllerComponents'
import { validScenes } from '@/util/sceneMap'

export default {
    components: {
        ...controllerComponents
    },

    props: {
        rootElement: {
            required: true,
            validator: o => o instanceof Element
        }
    },

    data() {
        return {
            vennAreas: validScenes.filter(
                s => s !== 'landing' && s !== 'intro'
            ),
            vennTitles: validScenes.filter(
                s => s !== 'landing' && s !== 'intro' && s !== 'overview'
            )
        }
    },

    computed: {
        vennElement() {
            return this.rootElement.querySelector('#venn-diagram')
        },

        vennAreaElements() {
            return this.vennAreas.map((s, i) => ({
                i,
                element: this.vennElement.querySelector(`#${s}`),
                sceneId: s
            }))
        },

        vennTitleElements() {
            return this.vennTitles.map((s, i) => ({
                i,
                element: this.rootElement.querySelector(`#${s}-title`),
                sceneId: s
            }))
        }
    }
}
</script>

<style>
</style>
